import {
    SET_LANGUAGE,
    SET_PAGE,
    SET_CURRENT_LINK,
    SET_CURRENCY,
    SET_MODULEDATA,
    HANDLE_GLOBAL_LNG_DATA,
    HANDLE_MODULE_LNG_DATA
} from '../mutation-types';
import util from '@/common/util';
import { localLanguage, localCurrency } from '@/globalization/localData';
import {
    defaultLngCode,
    defaultCurrencyCode,
    defaultCurrencySymbol
} from '@/globalization/constant.js';
import AllLang from '../../common/translate/googleTranslatePlugin/data.js';

const isArray_Object = function (value) {
    return (
        Object.prototype.toString.call(value) == '[object Object]' ||
        Array.isArray(value)
    );
};
const isEmptyObject = function (value) {
    Object.keys(value).length <= 0;
};

function mergeData(to, from, getSysLanguageCb) {
    let keys = Object.keys(from);
    let key,
        len = keys.length;
    for (let i = 0; i < len; i++) {
        key = keys[i];
        let toVal = to[key];
        let fromVal = getSysLanguageCb(toVal, from[key]);
        let fromValIsObj = isArray_Object(fromVal);
        let toValIsObj = isArray_Object(toVal);
        if (fromValIsObj && toValIsObj) {
            mergeData(toVal, fromVal, getSysLanguageCb);
            continue;
        }
        if (fromVal == undefined) {
            continue;
        }
        if (toValIsObj && !fromValIsObj) {
            console.info('Language mixing will affect the data structure');
        }
        to[key] = from[key];
    }
}

const fetcherSysLanguageModules = {
    'md-footer': true,
    'md-header': true
};

const CURRENCY_BIZ_TYPE = 'SITE';
const DEFAULT_BIZ_TYPE = 'DEFAULT';

function mergeLanguageToData(name, data, language, lng) {
    // if (!lng) {
    //     lng = globalization.lng();
    // }
    if (fetcherSysLanguageModules[name]) {
        mergeLanguageToData_fetcher(data, language, lng);
    } else {
        mergeLanguageToData_data(data, language, lng);
    }
    return data;
}
// Internationalized data is all in the same data equal sysLanguage middle 
function mergeLanguageToData_data(data, language, lng) {
    if (!language || !Object.keys(language).length) {
        return;
    }
    let languageObj = language[lng];
    if (!languageObj) {
        // if there is not language Attributes 
        languageObj = language[defaultLngCode];
    }
    if (!languageObj) {
        return;
    }
    mergeData(data, languageObj, (_, fromVal) => fromVal);
}
// The internationalization data section is stored in the data middle 

function mergeLanguageToData_fetcher(data, language, lng) {
    const mergeLanguage = fullSysLanguage => {
        let languageObj =
            fullSysLanguage[lng] ?? fullSysLanguage[defaultLngCode];
        if (languageObj && !isEmptyObject(languageObj)) {
            mergeData(data, languageObj, (_, fromVal) => fromVal);
        }
    };
    if (language && !isEmptyObject(language)) {
        mergeLanguage(language);
    }
    if (data.sysLanguage && !isEmptyObject(data.sysLanguage)) {
        mergeLanguage(data.sysLanguage);
    }
}

function findBaseSymbol(currencylist, currency) {
    const targetCurrency = currencylist.find(item => item.abbr === currency);
    return targetCurrency?.symbol || '$';
}

function getTargetInfo(currencyConfigList, type) {
    const targetInfo =
        currencyConfigList.find(item => item.currencyBizType === type) || {};
    return targetInfo.configInfoList?.[0] || {};
}

const store = {
    namespaced: true,
    state: () => ({
        currentLanguage: defaultLngCode,
        currentLink: '',
        currency: {
            symbol: defaultCurrencySymbol,
            abbr: defaultCurrencyCode
        },
        baseCurrency: 'USD', //  base currency 
        baseSymbol: '$', //  base currency symbol ， save search tag need to use 
        currencyRate: 1, //  exchange rate 
        usdCurrencyRate: 1, //  US dollar to current currency exchange rate 
        page: {},
        moduleData: []
    }),
    getters: {
        hasEmailLead(state) {
            var globalData = state.page;
            return (
                globalData &&
                globalData.site &&
                (globalData.site.emailLead ||
                    typeof globalData.site.emailLead === 'undefined')
            );
        },
        // chime | googlePlugin
        translatorType(state) {
            return state.page.translatorType;
        },
        languageMenus(state, getters) {
            switch (getters.translatorType) {
                case 'chime':
                    return state.page.sysLanguageList.map(l => {
                        return {
                            name: l.language,
                            label: l.nativeName,
                            img: l.icon
                        };
                    });
                case 'googlePlugin':
                    return state.page.language.options.map(name => {
                        let r = AllLang.find(v => v.name === name);
                        return {
                            name: name,
                            label: r.label.toUpperCase(),
                            img: r.img
                        };
                    });
                default:
                    return [];
            }
        },
        showCurrency(state) {
            let { openMultilingual, siteCurrencyList } = state.page || {};
            return (
                openMultilingual &&
                siteCurrencyList &&
                siteCurrencyList.length > 1
            );
        },
        currencyList(state) {
            return state.page.siteCurrencyList || [];
        },
        processedGlobalData(state) {
            return {
                ...(state.page || {}),
                currencySymbol: state.currency.symbol,
                baseCurrency: state.baseCurrency,
                currencyRate: state.currencyRate,
                baseSymbol: state.baseSymbol,
                currencyAbbr: state.currency.abbr
            };
        }
    },
    mutations: {
        [SET_LANGUAGE](state, lang) {
            state.currentLanguage = lang;
        },
        [SET_CURRENCY](state, currencyObj) {
            state.currency.name = currencyObj.name;
            state.currency.abbr = currencyObj.abbr;
            state.currency.symbol = currencyObj.symbol;
            localCurrency.set(currencyObj);
        },
        [SET_PAGE](state, page) {
            //  Global data should not be modified 
            state.page = Object.freeze(page) || {};
            //  from page It parses out the base currency ， Exchange rate and other information 
            const currencyConfigList = page?.currencyConfigList || [];
            const configInfo = getTargetInfo(
                currencyConfigList,
                CURRENCY_BIZ_TYPE
            );
            const defaultConfigInfo = getTargetInfo(
                currencyConfigList,
                DEFAULT_BIZ_TYPE
            );
            state.baseCurrency = configInfo.currency || 'USD';
            state.baseSymbol = findBaseSymbol(
                page?.siteCurrencyList || [],
                state.baseCurrency
            );
            state.currencyRate = configInfo.rate || 1;
            state.usdCurrencyRate = defaultConfigInfo.rate || 1;
        },
        [SET_CURRENT_LINK](state, currentLink) {
            state.currentLink = currentLink;
        },
        [SET_MODULEDATA](state, moduleData) {
            state.moduleData = moduleData || [];
        },
        [HANDLE_GLOBAL_LNG_DATA](state) {
            let lng = state.currentLanguage;
            for (let k in state.page) {
                const v = state.page[k];
                if (!v || !v.sysLanguage) {
                    continue;
                }
                mergeLanguageToData(null, v, v.sysLanguage, lng);
            }
        },
        [HANDLE_MODULE_LNG_DATA](state) {
            let lng = state.currentLanguage;
            state.moduleData.forEach(module => {
                if (!module.data) {
                    return;
                }
                mergeLanguageToData(
                    module.name,
                    module.data,
                    module.sysLanguage,
                    lng
                );
            });
        }
    },
    actions: {
        //  switch language ,  Will return whether it is actually applied 
        setLanguage({ commit, state, getters }, lang) {
            if (
                getters.translatorType &&
                state.currentLanguage !== lang &&
                getters.languageMenus.find(item => item.name == lang)
            ) {
                commit(SET_LANGUAGE, lang);
                if (getters.translatorType === 'chime') {
                    localLanguage.set(lang);
                    return Promise.resolve({ changed: true, isChime: true });
                } else if (getters.translatorType === 'googlePlugin') {
                    util.setCookie('chimetrans_gt', lang);
                    return Promise.resolve({ changed: true, isChime: false });
                }
            }
            return Promise.resolve({ changed: false });
        },
        selectCurrency({ commit }, payload) {
            commit(SET_CURRENCY, payload);
            window.location.reload();
        },
        //  according to cookie initialization currentLanguage
        initCurrentLang({ commit, state, getters }) {
            if (!getters.translatorType) {
                return;
            }
            if (getters.translatorType === 'chime') {
                const lang = localLanguage.get();
                if (getters.languageMenus.find(item => item.name == lang)) {
                    commit(SET_LANGUAGE, lang);
                }
                return;
            }
            // google translator
            const gtDefaultLng = state.page.language.default;
            const lang =
                util.getCookie('chimetrans_gt') || util.getCookie('chimetrans');
            if (lang && getters.languageMenus.find(item => item.name == lang)) {
                commit(SET_LANGUAGE, lang);
            } else if (gtDefaultLng) {
                commit(SET_LANGUAGE, gtDefaultLng);
            }
        },
        initCurrency({ commit, state, getters }) {
            if (!getters.showCurrency) {
                return;
            }
            const { siteCurrencyList, openMultilingual } = state.page;
            let abbr = localCurrency.get();
            if (!abbr) {
                if (siteCurrencyList.length <= 1 || !openMultilingual) {
                    //  set to dollar 
                    return localCurrency.reset();
                } else {
                    //  If the base currency is not in siteCurrencyList in ， USD is selected by default 
                    const baseCurrencyTarget = siteCurrencyList.find(
                        item => item.abbr === state.baseCurrency
                    );
                    if (!baseCurrencyTarget) {
                        return localCurrency.reset();
                    } else {
                        commit(SET_CURRENCY, baseCurrencyTarget);
                        return localCurrency.set({
                            abbr: state.baseCurrency,
                            symbol: state.baseSymbol
                        });
                    }
                }
            }
            for (let i = 0; i < siteCurrencyList.length; i++) {
                if (siteCurrencyList[i].abbr == abbr) {
                    return commit(SET_CURRENCY, siteCurrencyList[i]);
                }
            }
            localCurrency.reset();
            window.location.reload();
        }
    }
};

export default store;
